import React, { useEffect, useRef } from "react";
import FormattedDuration from "react-intl-formatted-duration";
import { FormattedMessage } from "react-intl";
import { ProgressBar, Spinner } from "react-bootstrap";
import { useSuperState } from "helpers/hooks";

export const TimedProgressBar = props => {

    const { duration } = props;

    const [state, setState] = useSuperState({
        seconds_remaining: duration
    });
    const { seconds_remaining } = state;

    const intervalRef = useRef(null);

    const decrementSecondsRemaining = () => {

        if (state.seconds_remaining > 0) setState({ seconds_remaining: state.seconds_remaining - 1 });

        else if (intervalRef?.current) clearInterval(intervalRef.current);

    };

    useEffect(() => {

        intervalRef.current = setInterval(decrementSecondsRemaining, 1000);

        return () => {

            clearInterval(intervalRef.current);

        };

    }, []);

    const progress_pct = Math.round((duration - seconds_remaining) / duration * 100);

    return (
        <>
            {seconds_remaining > 0 ?
                (
                    <div className="d-flex flex-column justify-content-center gap-5">
                        <div className="d-flex flex-column justify-content-center" style={{ height: 50 }}>
                            <ProgressBar animated now={progress_pct} width={250} />
                        </div>
                        <div className="text-center">
                            <h5 className="m-0">
                                <FormattedMessage
                                    id="label.your_session_will_begin_in_approxi.f147f23e"
                                    defaultMessage="Your session will begin in approximately"
                                />

                                <br/>

                                <FormattedDuration
                                    seconds={seconds_remaining}
                                    unitDisplay="short"
                                    format="{minutes} {seconds}"
                                />
                            </h5>
                        </div>
                    </div>
                )
                :
                (
                    <div className="text-center d-flex flex-column align-items-center justify-content-center gap-5">
                        <div style={{ height: 50 }}>
                            <Spinner animation="border" role="status">
                                <span className="visually-hidden">
                                    <FormattedMessage
                                        id="label.loading"
                                        defaultMessage="Loading..."
                                />
                                </span>
                            </Spinner>
                        </div>
                        <h5 className="m-0">
                            <FormattedMessage
                                id="label.your_session_will_begin_shortly"
                                defaultMessage="Your session will begin shortly."
                           />
                            <br/>
                            <FormattedMessage
                                id="label.thank_you_for_your_patience"
                                defaultMessage="Thank you for your patience!"
                            />
                        </h5>
                    </div>
                )
            }
        </>
    );

};